import { FC } from 'react'

type MarketplaceBannerType = {
  title: string
  description: string
  backgroundColor: string
  image: React.ReactNode
  imageContainerStyle?: React.CSSProperties
}

const MarketplaceBanner: FC<MarketplaceBannerType> = ({
  backgroundColor,
  description,
  image,
  imageContainerStyle,
  title,
}) => {
  return (
    <div
      className='card d-flex flex-row text-white'
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <div
        className='position-relative d-xl-flex d-none justify-content-center align-items-center'
        style={imageContainerStyle}
      >
        {image}
      </div>
      <div className='d-flex flex-column justify-content-center py-8 pt-lg-14 pb-lg-10 pe-lg-8 px-4 px-lg-6 px-xl-0 ml-xl-n4'>
        <h3 className='fs-36 fw-bold'>{title}</h3>
        <div
          className='fs-20 fw-bold'
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  )
}

export default MarketplaceBanner
